import { CButton, CCol, CContainer, CRow } from '@coreui/react';
import React, { useEffect, useState } from 'react';
import {CustomBreadcrumbs} from '../../components';
import { AppContext } from '../../context/AppContext';
import styles from './SettingsProducts.module.css';
import Modal from '../../components/Modal/Modal';
import ProductsTable from '../../components/Table/ProductsTable';
import { useNavigate } from 'react-router-dom';



const SettingsProducts = () => {

    //Context
    const { state, getProducts, } = React.useContext(AppContext);

    //States
    const columns = [
        {
          key: '',
          label: 'ID',
          _props: { scope: 'col' }
        },
        {
          key: 'title',
          label: 'Título',
          _props: { scope: 'col' }
        },
        {
          key: 'price',
          label: 'Precio',
          _props: { scope: 'col' }
        },
        {
          key: 'actions',
          label: 'Acciones',
          _props: { scope: 'col' }
        }
    ];

    const navigate = useNavigate();

    //Effect
    useEffect(() => {
        getProducts();
    },[])


    return (
        <>
            <CustomBreadcrumbs parentTitle={'Monetización'} activeTitle={"Productos"} />
            <CContainer>
                <CRow className="justify-content-center">
                    <CCol lg={12}>
                        <div className={styles.orderContainer}>
                            {/* Order header */}
                            <div className={styles.orderHeader}>
                                <h2 className='title'>Productos</h2>
                                <CButton 
                                    size="lg" 
                                    color="primary" 
                                    onClick={() => navigate("/dashboard/settings/products/add")} 
                                    className={styles.button}
                                >
                                    Agregar producto
                                </CButton>
                            </div>
                        </div>
                        <div className={styles.productsContainer}>
                            <ProductsTable
                                columns={columns} 
                                data={state?.products}
                                pagination={state?.productsPagination} 
                            />
                        </div>
                    </CCol>
                </CRow>
            </CContainer>
        </>
    );
};

export default SettingsProducts;
